import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { GasNetworkDamageModel, GasStationModel, GasStationsService, OrderModel } from '@core/api';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { OrderMapsServices } from '@core/components/services/order-maps.services';
import { OrderTimeService } from '@core/components/services/order-time.service';
import { UnexpectedErrorComponent } from '@ui/ui-errors';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { OrderService } from '@accounts/user/services/order.service';
import { ConfirmationDialogService } from '@ui/confirmation-dialog';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { UnexpectedErrorMessageService } from '@core/services';
import { MatDialog } from '@angular/material';
import { ModalDefectsListComponent } from '@accounts/user/components/modal-defects-list/modal-defects-list.component';
import * as moment from 'moment';
import { environment } from '../../../../../environments/environment';
import * as fileSaver from "file-saver";


@Component({
  selector: 'user-order-card-details',
  templateUrl: './order-card-details.component.html',
  styleUrls: ['./order-card-details.component.scss']
})
export class OrderCardDetailsComponent implements OnInit, OnDestroy {

  orderId: number;
  @Input() order: OrderModel;



  @Output() update = new EventEmitter();

  statusesMap = this.orderMapsServices.STATUSES;
  statuses = OrderModel.StatusEnum;
  currentDamages: GasNetworkDamageModel[] = [];
  transferring: boolean = false;
  returning: boolean = false;
  loading: boolean = false;
  allowedStatuses = [
    OrderModel.StatusEnum.Created,
    OrderModel.StatusEnum.Verified,
    OrderModel.StatusEnum.Paid
  ];

  time: number;
  orderTimer;
  rootTimer;

  returnGasStation: GasStationModel;
  constructor(
    public dialog: MatDialog,
    private orderMapsServices: OrderMapsServices,
    private orderServices: OrderTimeService,
    private orderService: OrderService,
    private gasStationService: GasStationsService,

    private confirmationDialogService: ConfirmationDialogService,
    private snackBar: UnexpectedErrorMessageService,
    private router: Router,
    private route: ActivatedRoute,
    private i18n: I18n
  ) {
    this.route.paramMap
      .pipe(tap((params: ParamMap) => this.orderId = Number(params.get('id'))))
      .pipe(switchMap(() => this.orderService.getOrder(this.orderId)))
      .pipe(tap((res) => {

        this.order = res;
        this.loading = true;
      }))
      .pipe(tap(() => {
        if (!!this.order.return_gas_station_id) {
          this.gasStationService.gasStationIdGet(this.order.return_gas_station_id).subscribe(({ data }) => {
            this.returnGasStation = data;
          })
        } else {
          this.returnGasStation = this.order.gasStation
        }
      }
      ))

      .subscribe();

  }

  get perLabel() {
    return this.orderServices.getStringOrderTime(this.order.tariff_type, this.order.rent_hours);
  }

  get createdAt() {
    return moment.utc(this.order.created_at, environment.dateFormat.server).local().format(environment.dateFormat.local);
  }

  get orderedTo() {
    return moment.utc(this.order.ordered_to, environment.dateFormat.server).local().format(environment.dateFormat.local);
  }

  get isShowTimer() {
    return this.time > 0 && this.allowedStatuses.includes(this.order.status);
  }

  private successUpdateStatus() {
    this.update.emit();
  }

  private errorUpdateStatus() {
    this.snackBar.openFromComponent(UnexpectedErrorComponent);
  }

  downloadTransferAct(id: number): void {
    this.orderService.downloadTransferAct(id).subscribe(response => {
      let blob: any = new Blob([response], { type: 'application/pdf; charset=utf-8' });
      fileSaver.saveAs(blob, 'trailer-transfer-act.pdf');
    }, error => {
      alert('Произошла ошибка. Не удалось выгрузить файл.');
    });
  }

  downloadReturnAct(id: number): void {
    this.orderService.downloadReturnAct(id).subscribe(response => {
      let blob: any = new Blob([response], { type: 'application/pdf; charset=utf-8' });
      fileSaver.saveAs(blob, 'trailer-return-act.pdf');
    }, error => {
      alert('Произошла ошибка. Не удалось выгрузить файл.');
    });
  }

  transfer() {
    this.confirmationDialogService.confirm({
      cancelBtnText: this.i18n('Отмена'),
      confirmBtnText: this.i18n('Принять'),
      message: this.i18n('Вы действительно хотите принять прицеп?'),
      title: this.i18n('Принять прицеп')
    })
      .then(() => {
        this.transferring = true;

        this.orderService.inRentTrailer(this.order.id)
          .pipe(finalize(() => this.transferring = false))
          .subscribe(
            () => this.successUpdateStatus(),
            () => this.errorUpdateStatus()
          )
      })
      .catch(error => { });
  }

  rejectOrder() {
    return this.confirmationDialogService.confirm({
      cancelBtnText: this.i18n('Назад'),
      confirmBtnText: this.i18n('Отменить'),
      message: this.i18n('Вы действительно хотите отменить заказ?'),
      title: this.i18n('Отмена заказа')
    })
      .then(() => {
        this.transferring = true;

        this.orderService.rejectOrder(this.order.id)
          .pipe(finalize(() => this.transferring = false))
          .subscribe(
            () => this.successUpdateStatus(),
            () => this.errorUpdateStatus()
          )
      })
      .catch(error => { });
  }

  return() {
    return this.confirmationDialogService.confirm({
      confirmBtnText: this.i18n('Закрыть'),
      message: this.i18n('Для возврата прицепа обратитесь к оператору'),
      title: this.i18n('Возврат прицепа')
    });
  }

  openNotesDialog(): void {
    this.dialog.open(ModalDefectsListComponent, {
      width: '600px',
      data: { id: this.order.id }
    });
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.orderTimer && this.orderTimer.unsubscribe();
    this.rootTimer && this.rootTimer.unsubscribe();
  }
}
